// Frontend error handling utilities
export const handleApiError = (error: any): string => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  if (error.message) {
    return error.message;
  }
  return 'An unexpected error occurred';
};

export const isApiError = (error: any): boolean => {
  return error.response?.data?.message !== undefined;
};

export const getApiErrorStatus = (error: any): number => {
  return error.response?.status || 500;
}; 